import Vue from 'vue';
import { DateTime } from 'luxon';

export default function (weekDay) {
  if (!weekDay) return 'N/A';
  return DateTime.fromISO(weekDay)
    .setLocale(Vue.$locale.locale)
    .toLocaleString(DateTime.DATE_HUGE);
}
